export default "__VITE_ASSET__XQvCuwsk__"